import Vue from 'vue'
Vue.filter('meter', (value) => {
  if (value !== undefined) {
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      return `${parseFloat(value).toFixed(2)} m2`
    } else {
      return value
    }
  }
})
